

















import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import Api from '@/common/api';
import { namespace } from 'vuex-class';
const userModule = namespace('user');

@Component({
  components: {
    Header,
  },
})
export default class Article extends Vue {
  @userModule.State('isLogin') isLogin!: boolean;

  title = '';
  body = '';

  async created () {
    const getArticles = async () => {
      const res = await Api.getShowArticle({
        articleId: this.$route.params.id,
      });
      if (res.bizCode === 10000) {
        this.title = res.data.title;
        this.body = res.data.body;
      } else {
        this.$router.push({
          name: 'home',
        });
      }
    };
    if (this.isLogin) {
      getArticles();
    } else {
      const res = await Api.createAnnoymousUser();
      if (res.bizCode === 10000) {
        Api.setAnonymousToken(res.data);
        getArticles();
      }
    }
  }
}
